import { cn } from '@/shared/lib/cn';
import { type InputHTMLAttributes, forwardRef } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        'h-9 w-full rounded-md border border-n-300 bg-n-0 px-3 text-sm text-n-900',
        'placeholder:text-n-400',
        'focus:border-brand-500 focus:outline-none focus:ring-[3px] focus:ring-brand-500/25',
        'disabled:bg-n-50 disabled:text-n-500',
        className,
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';
